import {Component, Input} from '@angular/core';

@Component({
    selector: 'vui-chip-text',
    templateUrl: './chip-text.component.html',
    styleUrls: ['./chip-text.component.scss']
})
export class ChipTextComponent {
    @Input() public title: string;
}
